const CallToActionControl = () => {
  return (
    <svg viewBox="0 0 1280 369" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect
        x="-1280"
        y="-369"
        width="3840"
        height="1107"
        fill="url(#grid-pattern-cta-control)"
        transform="translate(2, 10)"
      />
      <g>
        <ellipse
          opacity="0.25"
          cx="1050.5"
          cy="164"
          rx="25"
          ry="25"
          transform="rotate(-90 1050.5 164)"
          fill="#FF6183"
        />
        <path
          d="M1009.85 167.19C1009.7 166.277 1009.59 165.347 1009.54 164.403L1010.29 164.361C1010.26 163.911 1010.25 163.457 1010.25 163C1010.25 162.543 1010.26 162.089 1010.29 161.639L1009.54 161.597C1009.59 160.653 1009.7 159.723 1009.85 158.81L1010.59 158.935C1010.74 158.033 1010.94 157.149 1011.19 156.284L1010.47 156.076C1010.73 155.172 1011.04 154.289 1011.4 153.43L1012.09 153.718C1012.44 152.876 1012.83 152.059 1013.27 151.268L1012.62 150.905C1013.07 150.085 1013.57 149.293 1014.11 148.532L1014.72 148.967C1015.25 148.226 1015.81 147.517 1016.42 146.841L1015.86 146.341C1016.48 145.644 1017.14 144.982 1017.84 144.359L1018.34 144.918C1019.02 144.314 1019.73 143.747 1020.47 143.221L1020.03 142.609C1020.79 142.069 1021.58 141.57 1022.41 141.115L1022.77 141.771C1023.56 141.334 1024.38 140.939 1025.22 140.59L1024.93 139.897C1025.79 139.541 1026.67 139.231 1027.58 138.971L1027.78 139.692C1028.65 139.443 1029.53 139.241 1030.44 139.089L1030.31 138.35C1031.22 138.195 1032.15 138.091 1033.1 138.039L1033.14 138.788C1033.59 138.763 1034.04 138.75 1034.5 138.75C1034.96 138.75 1035.41 138.763 1035.86 138.788L1035.9 138.039C1036.85 138.091 1037.78 138.195 1038.69 138.35L1038.56 139.089C1039.47 139.241 1040.35 139.443 1041.22 139.692L1041.42 138.971C1042.33 139.231 1043.21 139.541 1044.07 139.897L1043.78 140.59C1044.62 140.939 1045.44 141.334 1046.23 141.771L1046.59 141.115C1047.42 141.57 1048.21 142.069 1048.97 142.609L1048.53 143.221C1049.27 143.747 1049.98 144.314 1050.66 144.918L1051.16 144.359C1051.86 144.982 1052.52 145.644 1053.14 146.341L1052.58 146.841C1053.19 147.517 1053.75 148.226 1054.28 148.967L1054.89 148.532C1055.43 149.293 1055.93 150.085 1056.38 150.905L1055.73 151.268C1056.17 152.059 1056.56 152.876 1056.91 153.718L1057.6 153.43C1057.96 154.289 1058.27 155.172 1058.53 156.076L1057.81 156.284C1058.06 157.149 1058.26 158.033 1058.41 158.935L1059.15 158.81C1059.3 159.723 1059.41 160.653 1059.46 161.597L1058.71 161.639C1058.74 162.089 1058.75 162.543 1058.75 163C1058.75 163.457 1058.74 163.911 1058.71 164.361L1059.46 164.403C1059.41 165.347 1059.3 166.277 1059.15 167.19L1058.41 167.065C1058.26 167.967 1058.06 168.851 1057.81 169.716L1058.53 169.924C1058.27 170.828 1057.96 171.711 1057.6 172.57L1056.91 172.282C1056.56 173.124 1056.17 173.941 1055.73 174.732L1056.38 175.095C1055.93 175.915 1055.43 176.707 1054.89 177.468L1054.28 177.033C1053.75 177.774 1053.19 178.483 1052.58 179.159L1053.14 179.659C1052.52 180.356 1051.86 181.018 1051.16 181.641L1050.66 181.082C1049.98 181.686 1049.27 182.253 1048.53 182.779L1048.97 183.391C1048.21 183.931 1047.42 184.43 1046.59 184.885L1046.23 184.229C1045.44 184.666 1044.62 185.061 1043.78 185.41L1044.07 186.103C1043.21 186.459 1042.33 186.769 1041.42 187.029L1041.22 186.308C1040.35 186.557 1039.47 186.759 1038.56 186.911L1038.69 187.65C1037.78 187.805 1036.85 187.909 1035.9 187.961L1035.86 187.212C1035.41 187.237 1034.96 187.25 1034.5 187.25C1034.04 187.25 1033.59 187.237 1033.14 187.212L1033.1 187.961C1032.15 187.909 1031.22 187.805 1030.31 187.65L1030.44 186.911C1029.53 186.759 1028.65 186.557 1027.78 186.308L1027.58 187.029C1026.67 186.769 1025.79 186.459 1024.93 186.103L1025.22 185.41C1024.38 185.061 1023.56 184.666 1022.77 184.229L1022.41 184.885C1021.58 184.43 1020.79 183.931 1020.03 183.391L1020.47 182.779C1019.73 182.253 1019.02 181.686 1018.34 181.082L1017.84 181.641C1017.14 181.018 1016.48 180.356 1015.86 179.659L1016.42 179.159C1015.81 178.483 1015.25 177.774 1014.72 177.033L1014.11 177.468C1013.57 176.707 1013.07 175.915 1012.62 175.095L1013.27 174.732C1012.83 173.941 1012.44 173.124 1012.09 172.282L1011.4 172.57C1011.04 171.711 1010.73 170.828 1010.47 169.924L1011.19 169.716C1010.94 168.851 1010.74 167.967 1010.59 167.065L1009.85 167.19Z"
          stroke="#FF6183"
          strokeWidth="1.5"
          strokeDasharray="3 3"
        />
        <path
          d="M994.25 164C994.25 150.607 1005.11 139.75 1018.5 139.75C1031.89 139.75 1042.75 150.607 1042.75 164C1042.75 177.393 1031.89 188.25 1018.5 188.25C1005.11 188.25 994.25 177.393 994.25 164Z"
          stroke="#FF6183"
          strokeWidth="1.5"
        />
        <ellipse
          cx="1002.5"
          cy="164"
          rx="25"
          ry="25"
          transform="rotate(-90 1002.5 164)"
          fill="#FF6183"
        />
        <g clipPath="url(#clip1_3878_22436)">
          <line
            x1="920.578"
            y1="261.646"
            x2="983.076"
            y2="199.149"
            stroke="#1BB694"
          />
          <line
            x1="920.578"
            y1="148.646"
            x2="983.076"
            y2="86.149"
            stroke="#1BB694"
          />
          <line
            x1="928.578"
            y1="261.646"
            x2="985.147"
            y2="205.078"
            stroke="#1BB694"
          />
          <line
            x1="913.578"
            y1="163.646"
            x2="970.147"
            y2="107.078"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="261.646"
            x2="983.076"
            y2="191.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="148.646"
            x2="983.076"
            y2="78.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="253.646"
            x2="983.076"
            y2="183.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="140.646"
            x2="983.076"
            y2="70.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="245.646"
            x2="983.076"
            y2="175.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="132.646"
            x2="983.076"
            y2="62.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="237.646"
            x2="983.076"
            y2="167.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="124.646"
            x2="983.076"
            y2="54.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="229.646"
            x2="983.076"
            y2="159.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="116.646"
            x2="983.076"
            y2="46.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="221.646"
            x2="983.076"
            y2="151.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="108.646"
            x2="983.076"
            y2="38.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="213.646"
            x2="983.076"
            y2="143.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="100.646"
            x2="983.076"
            y2="30.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="205.646"
            x2="983.076"
            y2="135.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="92.6464"
            x2="983.076"
            y2="22.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="197.646"
            x2="978.076"
            y2="132.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="84.6464"
            x2="978.076"
            y2="19.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="189.646"
            x2="970.076"
            y2="132.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="181.646"
            x2="970.076"
            y2="124.149"
            stroke="#1BB694"
          />
          <line
            x1="912.578"
            y1="173.646"
            x2="970.076"
            y2="116.149"
            stroke="#1BB694"
          />
        </g>
        <ellipse
          opacity="0.25"
          cx="725.5"
          cy="-9"
          rx="25"
          ry="25"
          transform="rotate(-180 725.5 -9)"
          fill="#FF6183"
        />
        <path
          d="M728.69 31.6505C727.777 31.8046 726.847 31.9091 725.903 31.9613L725.861 31.2125C725.411 31.2374 724.957 31.25 724.5 31.25C724.043 31.25 723.589 31.2374 723.139 31.2125L723.097 31.9613C722.153 31.9091 721.223 31.8046 720.31 31.6505L720.435 30.9109C719.533 30.7588 718.649 30.5568 717.784 30.3081L717.576 31.0289C716.672 30.7688 715.789 30.4592 714.93 30.103L715.218 29.4102C714.376 29.0613 713.559 28.6664 712.768 28.2286L712.405 28.8847C711.585 28.4304 710.793 27.9313 710.032 27.3908L710.467 26.7795C709.726 26.2532 709.017 25.6864 708.341 25.0823L707.841 25.6413C707.144 25.0179 706.482 24.3559 705.859 23.6587L706.418 23.1588C705.814 22.4832 705.247 21.7736 704.721 21.0332L704.109 21.4678C703.569 20.7073 703.07 19.9152 702.615 19.095L703.271 18.7316C702.834 17.9411 702.439 17.1237 702.09 16.2824L701.397 16.5697C701.041 15.7108 700.731 14.8278 700.471 13.9237L701.192 13.7164C700.943 12.8515 700.741 11.9667 700.589 11.0649L699.85 11.1897C699.695 10.2765 699.591 9.34651 699.539 8.40253L700.288 8.36111C700.263 7.91065 700.25 7.45684 700.25 7C700.25 6.54315 700.263 6.08934 700.288 5.63888L699.539 5.59746C699.591 4.65349 699.695 3.72347 699.85 2.81028L700.589 2.93507C700.741 2.03329 700.943 1.14851 701.192 0.283615L700.471 0.076305C700.731 -0.827757 701.041 -1.71081 701.397 -2.5697L702.09 -2.28241C702.439 -3.1237 702.834 -3.94114 703.271 -4.73161L702.615 -5.09499C703.07 -5.91525 703.569 -6.70728 704.109 -7.46776L704.721 -7.03324C705.247 -7.77362 705.814 -8.48321 706.418 -9.15878L705.859 -9.65873C706.482 -10.3559 707.144 -11.0179 707.841 -11.6413L708.341 -11.0823C709.017 -11.6864 709.726 -12.2532 710.467 -12.7795L710.032 -13.3908C710.793 -13.9313 711.585 -14.4304 712.405 -14.8847L712.768 -14.2286C713.559 -14.6664 714.376 -15.0613 715.218 -15.4102L714.93 -16.103C715.789 -16.4592 716.672 -16.7688 717.576 -17.0289L717.784 -16.3081C718.649 -16.5568 719.533 -16.7588 720.435 -16.9109L720.31 -17.6505C721.223 -17.8046 722.153 -17.9091 723.097 -17.9613L723.139 -17.2125C723.589 -17.2374 724.043 -17.25 724.5 -17.25C724.957 -17.25 725.411 -17.2374 725.861 -17.2125L725.903 -17.9613C726.847 -17.9091 727.777 -17.8046 728.69 -17.6505L728.565 -16.9109C729.467 -16.7588 730.351 -16.5568 731.216 -16.3081L731.424 -17.0289C732.328 -16.7688 733.211 -16.4592 734.07 -16.103L733.782 -15.4102C734.624 -15.0613 735.441 -14.6664 736.232 -14.2286L736.595 -14.8847C737.415 -14.4304 738.207 -13.9313 738.968 -13.3908L738.533 -12.7795C739.274 -12.2532 739.983 -11.6864 740.659 -11.0823L741.159 -11.6413C741.856 -11.0179 742.518 -10.3559 743.141 -9.65872L742.582 -9.15877C743.186 -8.48321 743.753 -7.77361 744.279 -7.03324L744.891 -7.46776C745.431 -6.70727 745.93 -5.91525 746.385 -5.09498L745.729 -4.7316C746.166 -3.94114 746.561 -3.12369 746.91 -2.2824L747.603 -2.56969C747.959 -1.7108 748.269 -0.827751 748.529 0.076311L747.808 0.283621C748.057 1.14852 748.259 2.0333 748.411 2.93507L749.15 2.81029C749.305 3.72348 749.409 4.6535 749.461 5.59748L748.712 5.63889C748.737 6.08935 748.75 6.54316 748.75 7C748.75 7.45685 748.737 7.91066 748.712 8.36112L749.461 8.40253C749.409 9.34651 749.305 10.2765 749.15 11.1897L748.411 11.0649C748.259 11.9667 748.057 12.8515 747.808 13.7164L748.529 13.9237C748.269 14.8278 747.959 15.7108 747.603 16.5697L746.91 16.2824C746.561 17.1237 746.166 17.9411 745.729 18.7316L746.385 19.095C745.93 19.9153 745.431 20.7073 744.891 21.4678L744.279 21.0332C743.753 21.7736 743.186 22.4832 742.582 23.1588L743.141 23.6587C742.518 24.3559 741.856 25.0179 741.159 25.6413L740.659 25.0823C739.983 25.6864 739.274 26.2532 738.533 26.7795L738.968 27.3908C738.207 27.9313 737.415 28.4304 736.595 28.8847L736.232 28.2286C735.441 28.6664 734.624 29.0613 733.782 29.4102L734.07 30.103C733.211 30.4592 732.328 30.7688 731.424 31.0289L731.216 30.3081C730.351 30.5568 729.467 30.7588 728.565 30.9109L728.69 31.6505Z"
          stroke="#FF6183"
          strokeWidth="1.5"
          strokeDasharray="3 3"
        />
        <path
          d="M725.5 47.25C712.107 47.25 701.25 36.3929 701.25 23C701.25 9.60709 712.107 -1.25001 725.5 -1.25C738.893 -1.25 749.75 9.6071 749.75 23C749.75 36.3929 738.893 47.25 725.5 47.25Z"
          stroke="#FF6183"
          strokeWidth="1.5"
        />
        <ellipse
          cx="725.5"
          cy="39"
          rx="25"
          ry="25"
          transform="rotate(-180 725.5 39)"
          fill="#FF6183"
        />
        <g clipPath="url(#clip2_3878_22436)">
          <line
            x1="823.146"
            y1="120.922"
            x2="760.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="710.146"
            y1="120.922"
            x2="647.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="823.146"
            y1="112.922"
            x2="766.578"
            y2="56.3538"
            stroke="#1BB694"
          />
          <line
            x1="725.146"
            y1="127.922"
            x2="668.578"
            y2="71.3535"
            stroke="#1BB694"
          />
          <line
            x1="823.146"
            y1="128.922"
            x2="752.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="710.146"
            y1="128.922"
            x2="639.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="815.146"
            y1="128.922"
            x2="744.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="702.146"
            y1="128.922"
            x2="631.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="807.146"
            y1="128.922"
            x2="736.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="694.146"
            y1="128.922"
            x2="623.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="799.146"
            y1="128.922"
            x2="728.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="686.146"
            y1="128.922"
            x2="615.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="791.146"
            y1="128.922"
            x2="720.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="678.146"
            y1="128.922"
            x2="607.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="783.146"
            y1="128.922"
            x2="712.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="670.146"
            y1="128.922"
            x2="599.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="775.146"
            y1="128.922"
            x2="704.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="662.146"
            y1="128.922"
            x2="591.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="767.146"
            y1="128.922"
            x2="696.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="654.146"
            y1="128.922"
            x2="583.649"
            y2="58.4249"
            stroke="#1BB694"
          />
          <line
            x1="759.146"
            y1="128.922"
            x2="693.649"
            y2="63.4249"
            stroke="#1BB694"
          />
          <line
            x1="646.146"
            y1="128.922"
            x2="580.649"
            y2="63.4249"
            stroke="#1BB694"
          />
          <line
            x1="751.146"
            y1="128.922"
            x2="693.649"
            y2="71.4249"
            stroke="#1BB694"
          />
          <line
            x1="743.146"
            y1="128.922"
            x2="685.649"
            y2="71.4249"
            stroke="#1BB694"
          />
          <line
            x1="735.146"
            y1="128.922"
            x2="677.649"
            y2="71.4249"
            stroke="#1BB694"
          />
        </g>
      </g>
      <defs>
        <pattern
          id="grid-pattern-cta-control"
          viewBox="0 0 40 40"
          width="1.04166667%"
          height="3.61336947%"
        >
          <rect
            width="40"
            height="40"
            fill="var(--color-background-inverted)"
          />
          <line
            x1="39"
            y1="0"
            x2="39"
            y2="39"
            stroke="var(--brand-color-grey-9)"
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
          <line
            x1="0"
            y1="39"
            x2="39"
            y2="39"
            stroke="var(--brand-color-grey-9)"
            strokeDasharray="2 2"
            strokeOpacity="0.5"
          />
        </pattern>

        <clipPath id="clip1_3878_22436">
          <rect
            width="40"
            height="159"
            fill="white"
            transform="translate(961.5 239) rotate(-180)"
          />
        </clipPath>
        <clipPath id="clip2_3878_22436">
          <rect
            width="40"
            height="159"
            fill="white"
            transform="translate(800.5 80) rotate(90)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default CallToActionControl;
